"use strict";var $export=require("./_export");$export($export.S,"Math",{clamp:function(t,r,e){return Math.min(e,Math.max(r,t))}});